import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { sortIcons } from 'helpers/icon_helpers';
import OverlayButton from './overlay_button';

export default class TableHeader extends React.Component {
  static propTypes = {
    allowSort: PropTypes.bool,
    children: PropTypes.node,
    currentColumns: PropTypes.array.isRequired,
    customHeaders: PropTypes.object,
    dedicatedColumnSelectCol: PropTypes.bool,
    defaultColumnMappings: PropTypes.object.isRequired,
    excludedColumns: PropTypes.array,
    hideOverlayFilters: PropTypes.func,
    includeSearchResults: PropTypes.bool,
    informationMappings: PropTypes.object.isRequired,
    showColumnFilters: PropTypes.bool,
    showOverlayFilters: PropTypes.func,
    sort: PropTypes.string,
    sortableColumnTypes: PropTypes.object,
    onSortChange: PropTypes.func,
  };

  static defaultProps = {
    allowSort: true,
    customHeaders: {},
    dedicatedColumnSelectCol: false,
    sortableColumnTypes: {},
    excludedColumns: [],
    includeSearchResults: false,
  };

  // ############## Sort Functions ##############
  activeSort() {
    const { sort } = this.props;

    if (sort == null) {
      return { field: null, direction: null };
    }

    const [field, direction] = sort.split(' ');
    return { field, direction };
  }

  handleSortChange = (sortOption) => {
    const { onSortChange } = this.props;

    onSortChange(sortOption);
  };
  // ############## Sort Functions End###########

  getColumnMappings = () => {
    const { informationMappings } = this.props;
    let columnMappings = {};

    Object.values(informationMappings).forEach((mapping) => {
      columnMappings = { ...columnMappings, ...mapping.mappings };
    });

    return columnMappings;
  };

  render() {
    return <>{this.renderColumns()}</>;
  }

  renderDefaultColumns = () => {
    const {
      customHeaders,
      defaultColumnMappings,
      currentColumns,
      includeSearchResults,
    } = this.props;

    const defaultHeaders = [];
    const mappingKeys = Object.keys(defaultColumnMappings);
    let index = 1;

    mappingKeys.forEach((key) => {
      const displaySelector =
        currentColumns.length === 0 && !includeSearchResults;

      if (customHeaders[key]) {
        defaultHeaders.push(customHeaders[key]);
      } else {
        defaultHeaders.push(
          this.renderHeaderCell(
            defaultColumnMappings[key],
            key,
            displaySelector && index == mappingKeys.length
          )
        );
      }

      index++;
    });

    return defaultHeaders;
  };

  renderColumns = () => {
    const { currentColumns, includeSearchResults } = this.props;

    const columnHeaders = [];
    const columnMappings = this.getColumnMappings();

    columnHeaders.push(this.renderDefaultColumns());

    if (includeSearchResults) {
      if (currentColumns.length === 0) {
        columnHeaders.push(
          <th key="search-results">
            <div className="float-start" name="search-results-header">
              Search Results
            </div>
            {this.renderColumnSelect()}
          </th>
        );
      } else {
        columnHeaders.push(
          <th key="search-results" name="search-results-header">
            Search Results
          </th>
        );
      }
    }

    currentColumns.map((column, index) => {
      columnHeaders.push(
        this.renderHeaderCell(
          columnMappings[column],
          column,
          currentColumns.length - 1 === index
        )
      );
    });

    return columnHeaders;
  };

  renderHeaderCell(label, fieldName, lastCell = false) {
    const { allowSort, excludedColumns, sortableColumnTypes } = this.props;

    const { field: sortedField, direction: sortedDirection } =
      this.activeSort();

    let onClickDirection = 'asc';
    const activeCell = sortedField === fieldName;
    if (activeCell && sortedDirection === 'asc') {
      onClickDirection = 'desc';
    }

    const columnData = sortableColumnTypes[fieldName];
    const iconSelector = columnData ? columnData : 'alpha';
    const icon = activeCell
      ? sortIcons[iconSelector][sortedDirection]
      : sortIcons.sort;

    const sortControl = (
      <FontAwesomeIcon
        className="ps-1 clickable sort-icon"
        icon={icon}
        onClick={() => this.handleSortChange(`${fieldName} ${onClickDirection}`)}
      />
    );

    const canRenderSortControl =
      allowSort && !excludedColumns.includes(fieldName);

    return (
      <React.Fragment key={fieldName}>
        <th className={classNames("text-nowrap", lastCell ? 'py-0' : undefined)}>
          <div>
            {label}
            {canRenderSortControl && sortControl}
          </div>
          {lastCell && !this.props.dedicatedColumnSelectCol && (
            <div key="column-select">{this.renderColumnSelect()}</div>
          )}
        </th>
        {lastCell && this.props.dedicatedColumnSelectCol && (
          <th key="column-select">{this.renderColumnSelect()}</th>
        )}
      </React.Fragment>
    );
  }

  renderColumnSelect() {
    return (
      <OverlayButton
        hide={!this.props.showColumnFilters}
        iconClass="ps-2"
        onClose={this.props.hideOverlayFilters}
        onOpen={this.props.showOverlayFilters}
      >
        {this.props.children}
      </OverlayButton>
    );
  }
}
